import React from 'react';
import ClickLink from 'App/components/styles/ClickLink';
import PropTypes from 'prop-types';
import { formatDate } from 'App/components/PatientProfile/PatientProfile.utils';

const propTypes = {
    canEnrollPatientMessaging: PropTypes.bool,
    showMessagingModal: PropTypes.func.isRequired,
    declinedAt: PropTypes.string.isRequired,
};

const defaultProps = {
    canEnrollPatientMessaging: true,
};

function Declined({ canEnrollPatientMessaging, showMessagingModal, declinedAt }) {
    const formattedDeclinedAt = formatDate(declinedAt);
    return (
        <>
            <div style={{ flexGrow: 1, flexBasis: '75%' }}>
                <i className="fas fa-fw fa-times text-danger" />
                <span>
                    Patient Messaging:{' '}
                    <span id="engage-patient-messaging-enrollment-status">
                        Patient Declined Enrollment {formattedDeclinedAt ? `(${formattedDeclinedAt}) ` : ''}
                    </span>
                </span>
                {canEnrollPatientMessaging ? (
                    <ClickLink onClick={showMessagingModal}>Enroll Patient</ClickLink>
                ) : (
                    <span>
                        {' | '}
                        <i className="fas fa-fw fa-info-circle text-info" />
                        Patient&apos;s branch is not configured for mobile messaging.
                    </span>
                )}
            </div>

            <div style={{ flexGrow: 1, flexBasis: '25%' }} />
        </>
    );
}

Declined.propTypes = propTypes;
Declined.defaultProps = defaultProps;

export default Declined;
